import { geoMercator } from "d3-geo";
import type { XY } from "./types";

export const makeProjection = (
  width: number,
  height: number,
  scale: number,
  center: [number, number]
) => geoMercator().center(center).scale(scale).translate([width / 2, height / 2]);

export const ringPixelsToLonLat = (project: d3.GeoProjection, pts: XY[]): [number, number][] =>
  pts.map(({ x, y }) => project.invert!([x, y]) as [number, number]);

export const ringLonLatToPixels = (project: d3.GeoProjection, ring: [number, number][]): XY[] =>
  ring.map(([lon, lat]) => {
    const [x, y] = project([lon, lat])!;
    return { x, y };
  });

export const ensureClosedLonLatRing = (ring: [number, number][]) => {
  if (!ring.length) return ring;
  const [fLon, fLat] = ring[0];
  const [lLon, lLat] = ring[ring.length - 1];
  if (fLon !== lLon || fLat !== lLat) {
    return [...ring, ring[0]];
  }
  return ring;
};
